module.exports = __webpack_public_path__ + "static/media/google-play.831d4a25.png";